import { QueryClient, VueQueryPlugin } from "@tanstack/vue-query";

export default defineNuxtPlugin((nuxtApp) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // The dashboard is API-driven; data refreshes on focus and a short
        // staleness window keeps navigation instant without going stale.
        staleTime: 15_000,
        retry: 1,
      },
    },
  });
  nuxtApp.vueApp.use(VueQueryPlugin, { queryClient });
});
